import React from "react";
import ReactDOM from "react-dom/client";
import {
  CometChatUIKit,
  UIKitSettingsBuilder,
} from "@cometchat/chat-uikit-react";

import App from "./App";
import { setupLocalization } from "./CometChat/utils/utils";
import { CometChatProvider } from "./CometChat/context/CometChatContext";
import cometChatLogo from "./CometChat/assets/cometchat_logo.svg";

// --- NEW CLERK IMPORTS ---
import { ClerkProvider } from "@clerk/clerk-react";

// This pulls your key from the Vercel dashboard / your local .env file
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.error("Missing Clerk Publishable Key!");
}

export const COMETCHAT_CONSTANTS = {
  APP_ID: "16690658bf8acd328",
  REGION: "eu",
  AUTH_KEY: "0a2c73baa5e4a8bb0858f4e97963328839e97436",
};

// Ensure we only create the root once
const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

if (
  COMETCHAT_CONSTANTS.APP_ID &&
  COMETCHAT_CONSTANTS.REGION &&
  COMETCHAT_CONSTANTS.AUTH_KEY
) {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(COMETCHAT_CONSTANTS.APP_ID)
    .setRegion(COMETCHAT_CONSTANTS.REGION)
    .setAuthKey(COMETCHAT_CONSTANTS.AUTH_KEY)
    .subscribePresenceForAllUsers()
    .build();

  // Capture the initialization result
  const initPromise = CometChatUIKit.init(uiKitSettings);

  if (initPromise) {
    initPromise
      .then(() => {
        console.log("CometChat initialized successfully");
        setupLocalization();
        root.render(
          // --- THE CLERK WRAPPER WITH DEV BADGE DISABLED ---
          <ClerkProvider 
            publishableKey={PUBLISHABLE_KEY || ""}
            appearance={{
              layout: {
                unsafe_disableDevelopmentModeWarnings: true,
              },
            }}
          >
            <CometChatProvider>
              <App />
            </CometChatProvider>
          </ClerkProvider>
        );
      })
      .catch((error) => {
        console.error("Initialization failed:", error);
        root.render(
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h2>Failed to initialize CometChat.</h2>
            <p>Check your console for specific errors.</p>
          </div>
        );
      });
  } else {
    console.error("CometChatUIKit.init() returned undefined.");
    root.render(
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Failed to initialize CometChat.</h2>
        <p>Initialization returned undefined. Check your UIKit settings.</p>
      </div>
    );
  }
} else {
  root.render(
    <div
      className="App"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        marginTop: "50px",
      }}
    >
      <img src={cometChatLogo} alt="CometChat Logo" style={{ width: "100px" }} />
      <div style={{ textAlign: "center" }}>
        CometChat App credentials are missing. Please add them in{" "}
        <code>index.tsx</code>.
      </div>
    </div>
  );
}